import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from "react-i18next";
import image1 from "images/image.png";
import mobileImage from "images/imagep.png"; // Mobile image

const Container = styled.div`
  position: relative;
  width: calc(100% + 200px);
  min-height: 600px;
  margin-left: -100px;
  margin-right: -100px;
  ${tw`flex items-center`}
  background: ${({ bg }) => `url(${bg}) center center / cover no-repeat`};
  transition: background-image 1s ease-in-out;
 @media (max-width: 768px) {
    background: url(${({ mobileBg }) => mobileBg}) center center / cover no-repeat;
  }
`;
const TwoColumn = tw.div`flex flex-col lg:flex-row items-center max-w-screen-xl mx-auto py-20 md:py-24`;
const RightColumn = tw.div`
  relative
  lg:w-6/12
  lg:pl-12
  flex
  flex-col
  items-start
  justify-center
  text-left
  mt-10
  lg:mt-0
  px-4
  mr-[500px]
`;

const Heading = tw.h1`
  font-black
  text-[2.5rem]
  md:text-5xl
  leading-tight
  max-w-3xl
  text-white
  whitespace-nowrap
  mb-2
`;

const Paragraph = tw.p`
  my-5
  lg:my-8
  text-sm
  lg:text-base
  font-medium
  text-white
  max-w-lg
  mx-0
  lg:mx-0
`;
const Actions = tw.div`flex flex-col items-center sm:flex-row justify-center lg:justify-start mt-8`;
const PrimaryButton = tw.a`
  font-bold px-8 lg:px-10 py-3 
  rounded-full 
  bg-[#133b8c] text-gray-100 
  hocus:bg-[#133b8c] 
  focus:shadow-outline focus:outline-none 
  transition duration-300
`;
const ButtonIcon = tw(FontAwesomeIcon)`mr-2`; // Adds margin to the right of the icon

export default () => {
    const { t } = useTranslation();
 const bg = image1;        // Desktop
  const mobileBg = mobileImage; // Mobile

  return (
    <Container bg={bg} mobileBg={mobileBg}>
      <TwoColumn>
        <RightColumn>
          {/* <Heading>{title}</Heading>
          <Paragraph>{text}</Paragraph>
          <Actions>
            <PrimaryButton href={buttonUrl} style={{marginTop:"-30px"}}>
              <ButtonIcon />
              {t("Découvrez")} &rarr;
            </PrimaryButton>
          </Actions> */}
        </RightColumn>
      </TwoColumn>

    </Container>
  );
};
